import {Separator, useComponentsTheme} from 'platform/components';
import {Box, Heading, HStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {RequiredTestIdProps} from 'shared/web';

interface CheckoutCardFrameProps extends RequiredTestIdProps {
  variant: 'inlineWhite' | 'inlineGrey';
  title: string;
  titleAddon?: ReactNode;
  isFullHeight: boolean;
  children: ReactNode;
}

// Not a platform Card: a full-height Card clips its body, and the choice menus of the checkout
// forms open inside it. The frame copies an inline Card with a title and a header separator.
export function CheckoutCardFrame(props: CheckoutCardFrameProps) {
  const componentsTheme = useComponentsTheme();

  return (
    <Box
      height={props.isFullHeight ? '100%' : undefined}
      borderRadius={componentsTheme.components.Card.borderRadius}
      backgroundColor={
        props.variant === 'inlineGrey' ? 'palettes.neutral.10.100' : 'palettes.white.10.100'
      }
      border="1px solid"
      borderColor="general.separator"
      data-testid={props['data-testid']}
    >
      <Box padding={4}>
        <HStack spacing={2} align="center">
          <Heading size={4}>{props.title}</Heading>
          {props.titleAddon}
        </HStack>
      </Box>
      <Separator spacing={0} />
      <Box padding={4}>{props.children}</Box>
    </Box>
  );
}
